<template>
	<b-container class="my-4">
		<b-col class="text-right">
			<el-select v-model="YearFilter" placeholder="Filter By Year" @change="generateChart">
				<el-option
				v-for="item in yearOptions"
				:key="item.name"
				:label="item.label"
				:value="item.name">
				</el-option>
			</el-select>
		</b-col>
		<br>
		<b-row>
			<b-col cols="6">
				<advisoryChart width="500" type="bar" :options="advisoryOptions" :series="advisorySeries"></advisoryChart>
			</b-col>
			<b-col cols="6">
				<totalChart width="500" type="bar" :options="totalOptions" :series="totalSeries"></totalChart>
			</b-col>
		</b-row>
	</b-container>
</template>
<script>
    import VueApexCharts from 'vue-apexcharts';
	import { Select, Option } from 'element-ui';
	import axios from 'axios'
    import {apiDomain, getHeader} from '@/assets/js/config.js'
    export default {
		
        components: {
            "advisoryChart": VueApexCharts,
            "totalChart": VueApexCharts,
			[Select.name]: Select,
      		[Option.name]: Option,
        },
		data() {
			return {
				// Total SSA / SSE starts
				advisorySeries: [
					{
						name: "SSE",
						data: [],
					},
					{
						name: "SSA",
						data: [],
					}
				],
				advisoryOptions: {
					chart: {
						type: 'bar',
						height: 500
					},
					plotOptions: {
						bar: {
							horizontal: false,
							columnWidth: '55%',
							endingShape: 'rounded'
						},
					},
					dataLabels: {
						enabled: false
					},
					stroke: {
						show: true,
						width: 2,
						colors: ['transparent']
					},
					xaxis: {
						categories: ['Jan','Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
					},
					yaxis: {
						title: {
							text: 'Report Downloaded By SSE / SSA'
						}
					},
					fill: {
						opacity: 1
					},
					tooltip: {
						y: {
							formatter: function (val) {
								return val + " reports downloaded"
							}
						}
					}
				}, // Total SSA / SSE ends
				// Total Download Report Start
				totalSeries: [{
					name: "Total Reports Downloaded",
					data: []
				}],
				totalOptions: {
					chart: {
						type: 'bar',
						height: 500
					},
					xaxis: {
						type: 'category',
						categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
						// group: {
						// 	style: {
						// 		fontSize: '10px',
						// 		fontWeight: 700
						// 	},
						// 	groups: [
						// 		{ title: '2019', cols: 4 },
						// 		{ title: '2020', cols: 4 }
						// 	]
						// }
					},
					title: {
						text: 'Total Reports Downloaded',
					},
				}, // Total Download ReportEnds
				yearOptions: [
					{
						name: '2023',
						label: '2023',
					}, 
					{
						name: '2022',
						label: '2022'
					}
				],
				YearFilter: 2023,
			}
		},
		created() {
			this.generateChart();
		},
		methods: {
			generateChart()
			{
				let ssecount = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
				let ssacount = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

				axios.get(apiDomain + 'financial_proposal/get_report_count_by_sse/' + this.YearFilter ,{ headers: getHeader() })
                .then ( response => {
					const obj = response.data.data

					Object.keys(obj).forEach(key => {
						ssecount[obj[key].month-1] = obj[key].total
					});

					this.advisorySeries[0].data = ssecount;
					this.advisoryOptions = {...this.advisoryOptions}
                })
                .catch ( error => {
                    _gNotif.errorFunction(error, "Error getting download report data")
                });	

				// generate chart for ssa and sse
				axios.get(apiDomain + 'financial_proposal/get_report_count_by_ssa/' + this.YearFilter ,{ headers: getHeader() })
                .then ( response => {
					const obj = response.data.data

					Object.keys(obj).forEach(key => {
						ssacount[obj[key].month-1] = obj[key].total
					});
					
					this.advisorySeries[1].data = ssacount;
					this.advisoryOptions = {...this.advisoryOptions}

				})
                .catch ( error => {
                    _gNotif.errorFunction(error, "Error getting download report data")
                });	

				// generate chart based on year and filter by month
				axios.get(apiDomain + 'financial_proposal/get_report_count_by_date/' + this.YearFilter ,{ headers: getHeader() })
                .then ( response => {
					const obj = response.data.data

					let report_count = [];
					let xaxis_name = [];

					Object.keys(obj).forEach(key => {
						report_count.push(obj[key].total);
						xaxis_name.push(obj[key].month)
					});
				
					this.totalSeries = [
						{
							data: report_count,
						}
					]

					this.totalOptions = {...this.totalOptions, 
						xaxis: {
							categories: xaxis_name,
						}
					};
                })
                .catch ( error => {
                    _gNotif.errorFunction(error, "Error getting download report data")
                });			
			},
		}
    }
</script>